module.exports = __webpack_public_path__ + "static/media/icon-visualizar-branco.35c11e1f.svg";